import { Container, Row, Col,Table,Button} from "reactstrap"
import React, { Component,useEffect,useState } from "react";

function Tabs({data,activeTab,updateState}){
	return(
		data.map((tab,index) => {
      return (
        <div className="ws_txt_tab"
        onClick={
          (e) => {
            updateState({
              activeTab: tab.id,
            })
          }
        }
        >{tab.name}</div>
      )

    })
	)
}

function Products({data,updateState}){
  return(
    <Container fluid>
      <Row>
        <Col xs={12}>
          <h1>Sección Productos</h1>
        </Col>
      </Row>
    </Container>
  )
}

function Inventory({arrCategorias, state, updateState}) {
  const { valSeach, viewTableType, finit, ffin, updateInventory, } = state
  return(
    <Container fluid className="mt-5">
      <input type="date" value={finit} className="form-control"
        onChange={(event) => {
          updateState({ finit: event.target.value, updateInventory: true, });
        }}              
      />
      {
        updateInventory ? <button
          onClick={() => {

            updateState({
              updateInventory: false,
            })

            fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=getStockAlmacen", {
              method: "POST",
              mode: "cors",
              body: JSON.stringify({
                fecha_init: finit,
                fecha_fin: ffin,
              }),
            })
            .then(response => response.json())
            .then((response) => {

              let { productos, categorias, } = response
              updateState({
                arrCategorias: categorias,
                arrStock: productos,
              })

            }).catch((error) => {})

          }}
          className={'btn btn-primary'}>Actualizar</button>
        : null
      }

      {
        arrCategorias.map((t0, e0) => (
          <div className={'ws__list_categorias_almacen'}>
            <Row className={`ws__list_categorias_almacen_p ${(t0.show && t0.list.length > 0) ? 'active' : ''}`} onClick={() => { onExpandSectionCate(t0, e0, state, updateState) }}>
              <Col style={{backgroundColor:'#8c6164',aligItems:'center'}}>
                <p style={{color:'#fff',fontWeight:'500', margin: 10, }}>{t0.nombre}</p>
              </Col>
              <Col style={{backgroundColor:'#8c6164'}}>
                <p style={{ fontSize: '.8rem', textAlign: 'right', color:'#fff',fontWeight:'500', margin: 10, }}>({nf(t0.list.length, 0)}) productos</p>
              </Col>
            </Row>

            {
              t0.show && t0.list.length > 0 ? (
                <div className={'ws__searchcnt'}>
                  <input
                    className="mt-2 mb-2"
                    type={'text'}
                    onChange={(event) => { updateState({ valSeach: event.target.value }) }}
                    placeholder={'Buscar un producto...'}
                    style={{ width: '100%', border: 0, backgroundColor: '#f3f3f3', padding: 4, borderRadius: 4, }}
                  />
                </div>
              ) : null
            }

            {
              t0.show && t0.list.length > 0 ? (
                <table className="table table-bordered table-hover table-sm">
                  <thead>
                    <tr>
                      <th >Nombre</th>
                      <th style={{ textAlign: 'center', }}>Adquisiciones de hoy</th>
                      <th style={{ textAlign: 'center', }}>Existencia en sistema</th>
                      <th style={{ textAlign: 'center', }}>Confirmar existencia</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      t0.list.map((t, e) => (
                        <>
                          {
                            valSeach === '' ||
                              t.clave.toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ||
                              t.nombre.trim().toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ? (
                              <tr key={"item_" + e} style={{ cursor: 'pointer', }}>
                                <td><p style={{ padding: '0', margin: '0' }}>{t.nombre}</p></td>
                                <td style={{ textAlign: 'center', }}><p>{nf(t.history_entradas - t.venta_kg, 2)}</p></td>
                                <td style={{ textAlign: 'center', }}>
                                  <input
                                    type={"number"} 
                                    onChange={(ev) => {
                                      arrCategorias[e0].list[e].confirmado = ev.target.value
                                      updateState({
                                        arrCategorias,
                                      });
                                    }}
                                    value={t.confirmado}
                                  />
                                </td>
                                <td style={{ textAlign: 'center', }}>
                                  {
                                    t.confirmado ? (
                                      <button onClick={() => { setUpdate(arrCategorias, state, e0, e, updateState) }} className={'btn btn-primary'}>Registrar</button>
                                    ) : null
                                  }
                                  {
                                    t.confirmado_inventario ? (
                                      <p>CONFIRMADO</p>
                                    ) : null
                                  }
                                </td>

                              </tr>
                            ) : null
                          }
                        </>
                      ))
                    }
                  </tbody>
                </table>
              ) : null
            }
          </div>
        ))
      }


    </Container>
  )
}

function onExpandSectionCate(t, e, state, updateState) {
  let { arrCategorias, } = state
  arrCategorias[e].show = !arrCategorias[e].show
  updateState({ arrCategorias, valSeach: '', })
}

function setUpdate(arrCategorias, state, e0, e, updateState) {

  let data = {
    ...arrCategorias[e0].list[e]
  }

  fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=setRegisterNewInventario", headersPOST({
    ...data,
    fecha_init: state.finit,
    fecha_fin: state.ffin,
  }))
  .then(response => response.json())
  .then((response) => {

    fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=getStockAlmacen", headersPOST({
      fecha_init: state.finit,
      fecha_fin: state.ffin,
    }))
    .then(response => response.json())
    .then((response) => {

      let { productos, categorias, } = response
      updateState({
        arrCategorias: categorias, arrStock: productos
      })

    }).catch((error) => {})

  }).catch((error) => {})

}


function headersPOST(data) {
  return {
    method: "POST",
    mode: "cors",
    body: JSON.stringify(data),
  }
}


function nf(number, decimals, decPoint, thousandsSep) {
  number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
  var n = !isFinite(+number) ? 0 : +number
  var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
  var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
  var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
  var s = ''
  var toFixedFix = function (n, prec) {
    var k = Math.pow(10, prec)
    return ''+(Math.round(n * k) / k)
    .toFixed(prec)
  }
  s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length+1).join('0')
  }
  return s.join(dec)
}

export {
  Tabs,
  Inventory,
  Products,
}